import { render, staticRenderFns } from "./ChangeLock.vue?vue&type=template&id=83cf786c&"
import script from "./ChangeLock.vue?vue&type=script&lang=js&"
export * from "./ChangeLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports